import React, { useContext, useEffect, useState } from 'react';
import { useLocation } from '@reach/router';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import styled from 'styled-components';
import { Context } from '@components/Context';
import Colors from '@components/shared/Colors';
import LinkTranslated from '@components/shared/LinkTranslated';
import SocialIcons from '@components/shared/SocialIcons';
import { getNavigationData } from '@data/navigation';
import { replaceText } from '@utils/handleTextReplacement';
import { isInternalLink } from '@utils/language';

interface Props {
  social: boolean;
}

const FooterLinks: React.FC<Props> = ({ social }) => {
  const {
    state: { country }
  } = useContext(Context);
  const location = useLocation();
  const {
    footer: { items: footerMenuItems }
  } = getNavigationData();
  const [hasMounted, setHasMounted] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    setHasMounted(true);
  }, []);

  if (!hasMounted) {
    return null;
  }

  return (
    <SectionTwo id="links">
      {social && <SocialIcons size={30} color={Colors.paleGold} />}
      <div style={{ height: 30 }} />
      <LinksInnerContainer>
        {footerMenuItems.map((item, index) => (
          <LinkTranslated to={item.link} key={index} targetBlank={!isInternalLink(item.link)}>
            {replaceText(t(item.title), country, location)}
          </LinkTranslated>
        ))}
      </LinksInnerContainer>
    </SectionTwo>
  );
};

export default FooterLinks;

const SectionTwo = styled.section`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  max-width: 440px;
  width: auto;

  @media (max-width: 1024px) {
    align-items: center;
  }
`;

const LinksInnerContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
  margin: 0 0 20px;
  width: 100%;
  justify-content: space-between;

  @media (max-width: 1024px) {
    margin-bottom: 86px;
  }

  a {
    font-family: 'BrownStd';
    font-size: 16px;
    font-weight: 400;
    line-height: 29px;
    letter-spacing: 0;
    text-align: left;
    color: ${Colors.cream};
    white-space: nowrap;
    width: 50%;

    @media (max-width: 1024px) {
      font-size: 14px;
      font-weight: 400;
      line-height: 28px;
      white-space: normal;
    }
  }
`;
